import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound.tsx';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { LalSegmentDetails } from '@openx/components-segment/lib/LalSegmentDetails/LalSegmentDetails.tsx';
import { useSegmentContext } from '@openx/components-segment/lib/utils/context/SegmentContext.tsx';
import { useShowLal } from '@openx/components-segment/lib/utils/useShowLal.ts';
import { useCanGoBack } from '@openx/utils/hooks/useCanGoBack.ts';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router';
import { DetailsHeaderAlerts } from './DetailsHeaderAlerts.tsx';
import { useHeaderActions } from './hooks/useHeaderActions.tsx';

export function LalSegmentDetailsPage() {
  const { t } = useTranslation();
  const showLal = useShowLal();

  const { lalSegmentUid } = useParams();
  const navigate = useNavigate();

  const { useLalSegmentFetch } = useSegmentContext();
  const { lalSegment, loading: lalSegmentLoading } = useLalSegmentFetch(lalSegmentUid ?? '');
  const { actions: headerActions } = useHeaderActions({ lalSegment });
  const canGoBack = useCanGoBack();

  const onGoBack = () => {
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate('/segments/lookalike');
    }
  };

  if (!showLal) {
    return <Navigate to="/segments/audience" />;
  }

  if (lalSegmentLoading) {
    return <Loader />;
  }

  if (!lalSegment || !lalSegmentUid) {
    return <PageNotFound appName={'OpenXSelect'} />;
  }

  const pageTitle = `${t('Details:')} ${lalSegment.lookalike_name}`;

  return (
    <PageHeader
      title={pageTitle}
      goBack={onGoBack}
      render={() => <HeaderActions actions={headerActions} />}
      titlePrefix={'OpenXSelect'}
    >
      <DetailsHeaderAlerts lalSegment={lalSegment} />
      <LalSegmentDetails lalSegment={lalSegment} />
    </PageHeader>
  );
}
